import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from '@material-ui/core';

import TextField from '../../../../../../Common/UI/TextField';
import SelectTextField from '../../../../../../Common/UI/SelectTextField';
import { Autocomplete } from '@material-ui/lab';

class WithinRule extends React.Component {
    static propTypes = {
        tree: PropTypes.object.isRequired,
        field: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);

        this.handleLayerChange = this.handleLayerChange.bind(this);
        this.sortLayers = this.sortLayers.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    

    componentDidMount(){
        const { tree, onChange } = this.props;
        const value = tree?.properties?.value;
        const unit = tree?.properties?.unit;
        if(value === undefined || unit === undefined) tree["isValid"] = false;
        else tree["isValid"] = true;
        onChange(tree);
    }

    handleLayerChange (event, item) {
        const { tree, onChange } = this.props;
        const newTree = { ...tree };
        newTree.properties = {
            'layer': item.value
        };
        newTree.children = [];
        if(newTree.properties?.layer === undefined) newTree["isValid"] = false;
        if(newTree.properties?.layer !== undefined) newTree["isValid"] = true;
        onChange(newTree);
    }

    sortLayers (a, b) {
        const categoryA = a.category || '';
        const categoryB = b.category || '';
        if (categoryA < categoryB) { return -1; }
        if (categoryA > categoryB) { return 1; }
        if ((a.label || a.value) < (b.label || b.value)) { return -1; }
        if ((a.label || a.value) > (b.label || b.value)) { return 1; }
        return 0;
    }

    handleChange (event) {
        const { tree, onChange } = this.props;
        const newTree = { ...tree };
        newTree.properties = {
            ...newTree.properties,
            [event.target.name]: event.target.type === 'number' ? Number(event.target.value) : event.target.value
        };
        const value = newTree?.properties?.value;
        const unit = newTree?.properties?.unit;
        const layer = newTree?.properties?.layer;
        if(layer === undefined) newTree["isValid"] = false;
        else if(value === undefined || unit === undefined) newTree["isValid"] = false;
        else newTree["isValid"] = true;
        onChange(newTree);
    }

    render () {
        const { tree, field } =this.props;
        const { properties } = tree;

        const options = field.settings.listOptions.sort(this.sortLayers);
        const value = options.find(el => el.value === tree.properties.layer) || null;

        return (
            <>
                <Autocomplete
                    renderInput={params =>
                        <TextField
                            inputRef={params.InputProps.ref}
                            inputProps={params.inputProps}
                            size="small"
                            placeholder={field.settings.listPlaceholder || 'Layer'}
                        />
                    }
                    getOptionLabel={option => option.label || option.value}
                    options={options}
                    groupBy={option => option.category}
                    value={value}
                    onChange={this.handleLayerChange}
                    disableClearable
                />
                <TextField
                    disabled={tree?.properties?.layer === undefined}
                    type="number"
                    style={{ width: '100px' }}
                    name="value"
                    size="small"
                    onChange={this.handleChange}
                    placeholder={field.placeholder || 'Value'}
                    value={properties.value != null ? properties.value : ''}
                    inputProps={{ min: 0 }}
                    error={properties.value === undefined || properties.value === null}
                />
                <SelectTextField
                    name="unit"
                    onChange={this.handleChange}
                    value={properties.unit != null ? properties.unit : ''}
                    placeholder="Unit"
                    size="small"
                    disabled={tree?.properties?.layer === undefined}
                >
                    <MenuItem value="m">{'m'}</MenuItem>
                    <MenuItem value="km">{'km'}</MenuItem>
                    <MenuItem value="mi">{'mi'}</MenuItem>
                </SelectTextField>
            </>
        );
    }
}

export default WithinRule;